module.exports = __webpack_public_path__ + "assets/a3620744313d7b98182b741c876fbbad.png";